/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { object, string, array } from 'prop-types';

const PageHeading = ({
    classes, headingTitle, titleFontColor, subTitle, listItem,
}) => (
    <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.headingBlock}>
            <div>
                <h1 className={classes.headingTitle} style={{ color: `${titleFontColor}` }}>{headingTitle}</h1>
                <div className={classes.headingSubTitle}>{subTitle}</div>
            </div>
            <div className={classes.listBlock}>
                <ul>
                    {listItem.map((list, i)  => (
                        <li className={classes.listItem} key={['_', i].join('')}>{list}</li>
                    ))}
                </ul>
            </div>

        </Grid>
    </Grid>
);

PageHeading.propTypes = {
    classes: object.isRequired,
    headingTitle: string.isRequired,
    titleFontColor: string.isRequired,
    subTitle: string.isRequired,
    listItem: array.isRequired,
};

export default PageHeading;
